import { Button } from '@material-ui/core';
import CloseIcon from '@mui/icons-material/Close';
import WarningAmberIcon from '@mui/icons-material/WarningAmber';
import { Stack, Typography, Modal } from '@mui/material';

const style = {
	position: 'absolute',
	top: '50%',
	left: '50%',
	transform: 'translate(-50%, -50%)',
	width: 500,
	bgcolor: '#f6f7f9',
	color: 'text.primary',
	borderRadius: '12px',
	boxShadow: 24,
	p: 4
};

function WarningModal({ open, handleClose, handleOk, message = 'Вы уверены, что хотите продолжить?' }) {
	return (
		<Modal
			open={open}
			onClose={handleClose}
			aria-labelledby="warning-modal-title"
			aria-describedby="warning-modal-description"
		>
			<Stack gap={3} sx={style} position="relative">
				<CloseIcon
					onClick={handleClose}
					sx={{
						position: 'absolute',
						top: 16,
						right: 16,
						width: 20,
						height: 20,
						color: '#black',
						cursor: 'pointer'
					}}
				/>

				<Stack direction="row" alignItems="center" gap={1}>
					<WarningAmberIcon sx={{ color: '#ff9800', fontSize: 40 }} />
					<Typography id="warning-modal-title" variant="h4" style={{ fontWeight: 'bold' }} color="black">
						Вы не сможете отменить это действие после продолжения.
					</Typography>
				</Stack>

				<span id="warning-modal-description" style={{ fontSize: '24px' }}>
					{message}
				</span>

				<Stack direction="row" justifyContent="flex-end" gap={1}>
					<Button onClick={handleOk} variant="contained" color='primary'>
						Продолжать
					</Button>
				</Stack>
			</Stack>
		</Modal>
	);
}

export default WarningModal;
